import { MicrosoftAuthConfig } from '@msal';

export const environment = {
  name: 'prod',
  production: true,
  remoteApi: 'https://merchadmin-api.rmxrewardstore.com/api',

  microsoft: {
    clientId: '369690ed-f361-4e93-8d34-f6670e03e5d1',
    authority: 'https://login.microsoftonline.com/6a7ef1e2-9e9e-412e-9824-b8c2856ce8f4',
    redirectUri: 'https://merchadmin.rmxrewardstore.com',
    protectedResources: [
      {
        url: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['user.read'],
      },
      {
        url: 'https://rmx-adminapp-prod-cus-web-app.azurewebsites.net/',
        scopes: ['api://369690ed-f361-4e93-8d34-f6670e03e5d1/Default'],
      },
      {
        url: 'https://agreeable-hill-07bc14410.6.azurestaticapps.net/',
        scopes: ['api://369690ed-f361-4e93-8d34-f6670e03e5d1/Default'],
      },
      {
        url: 'https://merchadmin.rmxrewardstore.com/',
        scopes: ['api://369690ed-f361-4e93-8d34-f6670e03e5d1/Default'],
      },
      {
        url: 'https://merchadmin-api.rmxrewardstore.com/',
        scopes: ['api://369690ed-f361-4e93-8d34-f6670e03e5d1/Default'],
      },
    ],
    protectedResourcesDefaultScope: ['api://369690ed-f361-4e93-8d34-f6670e03e5d1/Default'],
  } satisfies MicrosoftAuthConfig,
};
